import React from 'react';

import "./styles.scss";

export const LoadingScreen = () => {
    return (
        <div className="loading-screen">
            <div className="spinner"></div>
        </div>
    );
};
